import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IBudgetFiltersResponseDto } from '@epicuro-next/models/seller-tools';

import { BUDGET_API_TOKEN } from '../token';

@Injectable()
export class BudgetFiltersService {
  private readonly api: string = inject(BUDGET_API_TOKEN);
  private readonly http: HttpClient = inject(HttpClient);

  public getFilters() {
    return this.http.get<IBudgetFiltersResponseDto>(`${this.api}/filters`);
  }
}
